import React, { useContext } from 'react';

/// React router dom
import { Routes, Route, Outlet } from 'react-router-dom';

/// Css
import './index.css';
import './chart.css';
import './step.css';

/// Layout
import Nav from './layouts/nav';
import ScrollToTop from './layouts/ScrollToTop';

/// Pages
import LockScreen from './pages/LockScreen';
import Login from './pages/Login';
import Registration from './pages/Registration';
import ForgotPassword from './pages/ForgotPassword';
import Error400 from './pages/Error400';
import Error403 from './pages/Error403';
import Error404 from './pages/Error404';
import Error500 from './pages/Error500';
import Error503 from './pages/Error503';
import Setting from './layouts/Setting';
import { ThemeContext } from '@context/ThemeContext';
import Introduction from './components/Introduction';
import About from './components/About';
import Rooms from './components/Rooms';
import Services from './components/Services';
import Contact from './components/Contact';
import Destinations from './components/Destinations';
import Events from './components/Events';
import Offers from './components/Offers';
import Subscribers from './components/Subscribers';
import Comments from './components/Comments';
import Experiences from './components/Experiences';
import Dinings from './components/Dinings';
import SpaWellness from './components/SpaWellness';
import Accounts from './components/Accounts';
import Galleries from './components/Galleries';

const Markup = () => {
  let path = window.location.pathname;
  path = path.split('/');
  path = path[path.length - 1];
  const pagePath = path.split('-').includes('page');

  return (
    <>
      <Routes>
        <Route path="lock-screen" element={<LockScreen />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<MainLayout />}>
          <Route path="/" element={<Introduction />} />
          <Route path="introduction" element={<Introduction />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="dinings" element={<Dinings />} />
          <Route path="spa-wellness" element={<SpaWellness />} />
          <Route path="experiences" element={<Experiences />} />
          <Route path="events" element={<Events />} />
          <Route path="destinations" element={<Destinations />} />
          <Route path="offers" element={<Offers />} />
          <Route path="galleries" element={<Galleries />} />
          <Route path="subscribers" element={<Subscribers />} />
          <Route path="comments" element={<Comments />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="error-400" element={<Error400 />} />
          <Route path="error-403" element={<Error403 />} />
          <Route path="error-404" element={<Error404 />} />
          <Route path="error-500" element={<Error500 />} />
          <Route path="error-503" element={<Error503 />} />
        </Route>
        <Route path="/*" element={<Error404 />} />
      </Routes>
      <Setting />
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);

  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? 'iconhover-toggle' : ''} ${
        menuToggle ? 'menu-toggle' : ''
      }`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Markup;
